import React, {  useState } from "react";
import { ChevronLeft } from "react-bootstrap-icons";
import Style from "./Accardion.module.scss";
import { BasketFill } from "react-bootstrap-icons";
import AccardionItem from "./AccardionItem/AccardionItem";
import { Badge } from "antd";
const Accardion = ({dataCount}) => {
  const [openOnClick,setOpenOnClick]=useState(false)
  const OrderItem = [
    {
      id: "6",
      title: "همه",
      link: "/allorderfood",
      active: window.location.pathname === "/allorderfood",
      count:parseInt(dataCount?.total)
    },
    {
      id: "1",
      title: "فعال",
      link: "/activeorderfood",
      active: window.location.pathname === "/activeorderfood",
      count:parseInt(dataCount?.active)
    },
    {
      id: "5",
      title: "تحویل داده شده",
      link: "/ordersdeliveredfood",
      active: window.location.pathname === "/ordersdeliveredfood",
      count:parseInt(dataCount?.delivered)
    },
    {
        id: "2",
        title: "پرداخت نشده",
        link: "/notpaidorder",
        active: window.location.pathname === "/notpaidorder",
        count:parseInt(dataCount?.not_paied)
    },
    {
        id: "3",
        title: "کنسل شده",
        link: "/canceledorder",
        active: window.location.pathname === "/canceledorder",
        count:parseInt(dataCount?.canceled)
    },
  ];
  let value = false;
  OrderItem.forEach((element) => {
    if (element.active) {
      value = true;
    }
  });
  const openHandler = () => {
    setOpenOnClick(!openOnClick)
  };
  return (
    <div className={Style.accardionChild}>
      <div
        className={
          value || openOnClick ? Style.background : Style.accardionTitle
        }
        onClick={openHandler}
      >
        <ChevronLeft />
        <div className={Style.right}>
          <p className={Style.accardionText}> <Badge count={dataCount?.total}/> سفارشات</p>
          <BasketFill />
        </div>
      </div>
      {OrderItem === undefined ? null : (
        <div
          className={
            value || openOnClick ? Style.accardionContent : Style.hidden
          }
        >
          <AccardionItem accardonItem={OrderItem && OrderItem} />
        </div>
      )}
    </div>
  );
};

export default Accardion;
